<template>
  <div class="navigator" :style="{ '--color': color.theme }">
    <div v-if="!hideBackButton" class="back" @click="goBack">
      <img class="back__image" :src="BackIcon" alt="back" />
    </div>
    <div v-else class="back" @click="openMenu">
      <img v-if="!mapMenuOpen" :src="menuIcon" />
      <img v-else :src="closeIcon" />
    </div>
    <div v-if="!hideFavAndDes" class="icon-left">
      <img
        class="favorite"
        :src="Favorite"
        alt="favorite"
        @click="goToFavorite"
      />
    </div>
    <div v-if="title || originTitle" class="title">
      <span v-if="!originTitle">{{ title }}</span>
      <span v-else>{{ originTitle }}</span
      >{{ envStatus }}
    </div>
    <div v-if="!hideFavAndDes" class="icon-right">
      <img
        class="description"
        :src="Description"
        alt="description"
        @click="showToggleDialog"
      />
      <img class="share" :src="Share" alt="share" @click="share" />
    </div>
  </div>
  <div
    class="map-menu"
    :class="{ 'map-menu-open': mapMenuOpen }"
    :style="{ '--color': color.backGround }"
  >
    <div
      class="map"
      :class="{ selected: selectIndex === mapData.length + 1 }"
      @click="backToMaps"
    >
      回到《地圖一覽》
    </div>
    <div
      v-for="(map, index) in mapData"
      v-show="map.status === 0 || map.status === 1"
      :key="index"
      class="map"
      :class="{ selected: index === selectIndex }"
      :style="{ '--color': color.text }"
      @click="selectMapItem(index)"
    >
      <span>{{ map.name }}</span>
    </div>
  </div>
</template>

<script>
const IS_UAT = process.env.VUE_APP_ISUAT; // or is mock
const MAPLIST_URL = process.env.VUE_APP_MAPLIST_URL;

import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import emitter from '../helpers/emitter';
import menuIcon from '../images/icon/i-map-menu.svg';
import closeIcon from '../images/icon/i-cross-white.svg';
import BackIcon from '../images/icon/i-angle-arrow_left_w.svg';
import Description from '../images/icon/i-nav-description.svg';
import Favorite from '../images/icon/i-nav-favorite.svg';
import Share from '../images/icon/i-nav-share.svg';

export default {
  name: 'Navigator',
  props: {
    backAction: {
      type: Function,
      default: null,
    },
    closeAction: {
      type: Function,
      default: () => {
        window.closeWindow();
      },
    },
    replaceBack: {
      type: Boolean,
      default: false,
    },
    replaceTo: {
      type: String,
      default: 'home',
    },
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const hideBackButton = ref(true);
    const projectCode = process.env.VUE_APP_PROJECTCODE;

    let backButtonStatus = '';
    emitter.on('backButtonStatus', (data) => checkBackButtonStatus(data));
    const checkBackButtonStatus = (data) => {
      hideBackButton.value = false;
      backButtonStatus = data;
    };

    emitter.on('hideBackButtonFromHasNoFavoriteList', (status) =>
      hideBackButtonFromHasNoFavoriteList(status),
    );
    const hideBackButtonFromHasNoFavoriteList = (status) => {
      hideBackButton.value = status;
      hideFavAndDes.value = false;
      backButtonStatus = '';
    };

    const hideFavAndDes = ref(false);
    emitter.on('hideFavAndDes', (status) => hideFavAndDesButton(status));
    const hideFavAndDesButton = (status) => {
      hideFavAndDes.value = status;
    };

    const mapName = computed(() => store.getters.getMapName());
    const originTitle = ref('');
    const favTitle = '收藏店鋪';
    const title = computed({
      get: () => mapName.value,
      set: (val) => {
        originTitle.value = val;
      },
    });
    emitter.on('changeTitleFromDetail', (data) =>
      changeTitleFromDetailPage(data),
    );
    const changeTitleFromDetailPage = (data) => {
      title.value = data;
    };

    const goBack = () => {
      switch (backButtonStatus) {
        case 'favorite':
          emitter.emit('showStoreDetail', false);
          emitter.emit('showFavoriteList', false);
          hideBackButton.value = true;
          hideFavAndDes.value = false;
          title.value = mapName.value;
          backButtonStatus = '';
          break;
        case 'storeInfoFav':
          emitter.emit('showStoreDetail', false);
          backButtonStatus = 'favorite';
          title.value = favTitle;
          break;
        case 'storeInfo':
          emitter.emit('showStoreDetail', false);
          hideBackButton.value = true;
          hideFavAndDes.value = false;
          title.value = mapName.value;
          break;
        case 'storeInfoMap':
          emitter.emit('showStoreDetail', false);
          emitter.emit('showFavoriteList', false);
          hideBackButton.value = true;
          hideFavAndDes.value = false;
          title.value = mapName.value;
          break;
      }
    };

    const color = computed(() => {
      return {
        theme: store.getters.getColor(1),
        text: store.getters.getColor(2),
        backGround: store.getters.getColor(4),
      };
    });

    const selectIndex = ref(0);
    const mapData = ref([]);
    const mapMenuOpen = ref(false);
    const openMenu = () => {
      if (!mapMenuOpen.value) {
        commonUseGA('漢堡選單');
      }
      if (mapData.value.length === 0) {
        mapData.value = store.getters.getMapList();
        mapData.value.forEach((item, idx) => {
          if (item.name === mapName.value) {
            selectIndex.value = idx;
          }
        });
      }
      mapMenuOpen.value = !mapMenuOpen.value;
    };

    const token = ref('');
    const memberCode = ref('');
    const selectMapItem = (idx) => {
      if (selectIndex.value !== idx) {
        selectIndex.value = idx;
        const gaData = {
          page: '地圖趣',
          obj_category: '地圖趣活動頁',
          action: '跳轉地圖',
          label: mapData.value[idx].projectCode,
          item_id: projectCode,
          item_name: mapName.value,
          user_id: memberCode.value,
          cno: memberCode.value,
        };
        // eslint-disable-next-line
        gtag('event', 'click', gaData);

        token.value = store.getters.getToken() || route.query.t;
        memberCode.value = store.getters.getMemberCode() || route.query.m;
        const url = mapData.value[idx].mapUrl;

        setTimeout(() => {
          window.location.href = `${url}?t=${token.value}&m=${memberCode.value}`;
        }, 50); // 延遲到效果出現而已
      }
      mapMenuOpen.value = !mapMenuOpen.value;
    };

    const backToMaps = () => {
      selectIndex.value = mapData.value.length + 1;
      const url = MAPLIST_URL;
      setTimeout(() => {
        window.location.href = `${url}?t=${token.value}&m=${memberCode.value}`;
      }, 50); // 延遲到效果出現而已
    };

    const showToggleDialogSwitch = ref(false);
    const showToggleDialog = () => {
      commonUseGA('說明');
      emitter.emit('showToggleDialog', true);
    };

    const goToFavorite = () => {
      if (backButtonStatus === 'favorite') return;
      emitter.emit('showStoreDetail', false);
      emitter.emit('showFavoriteList', true);
      backButtonStatus = 'favorite';
      title.value = favTitle;
      hideBackButton.value = false;
      commonUseGA('收藏店舖');
    };

    const wording = computed(() => store.getters.getShareMessage());
    const share = () => {
      emitter.emit('share', true);
      const base64ProjectCode = process.env.VUE_APP_PROJECTCODE_BASE64;
      const shareUrl = process.env.VUE_APP_SHARE_REDIRECT_URL;
      const shareStr = `${wording.value}\r\n ${shareUrl}${base64ProjectCode} `;

      if (typeof window.mobileShare !== 'undefined') {
        window.mobileShare(shareStr);
      }
      const gaData = {
        page: '地圖趣',
        obj_category: '分享',
        action: '分享',
        item_id: projectCode,
        item_name: mapName.value,
        user_id: memberCode.value,
        cno: memberCode.value,
      };
      // eslint-disable-next-line
      gtag('event', 'share', gaData);
      commonUseGA('分享');
    };
    const commonUseGA = (data) => {
      const gaData = {
        page: '地圖趣',
        obj_category: '地圖趣活動頁',
        action: '點擊上方功能',
        label: data,
        item_id: projectCode,
        item_name: mapName.value,
        user_id: memberCode.value,
        cno: memberCode.value,
      };
      // eslint-disable-next-line
      gtag('event', 'click', gaData);
    };

    const envStatus = IS_UAT === 'true' ? ref('-UAT') : ref('');

    return {
      BackIcon,
      menuIcon,
      closeIcon,
      mapMenuOpen,
      mapData,
      selectIndex,
      hideBackButton,
      hideFavAndDes,
      title,
      originTitle,
      color,
      goBack,
      openMenu,
      selectMapItem,
      backToMaps,
      close,
      showToggleDialog,
      goToFavorite,
      share,
      showToggleDialogSwitch,
      Description,
      Favorite,
      Share,
      envStatus,
    };
  },
};
</script>

<style lang="scss" scoped>
.navigator {
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  padding: 11px var(--space-percent-2);
  color: white;
  background-color: var(--color);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 1125;

  .back {
    position: absolute;
    left: 0px;
    padding: 0 0 0 16.5px;
    width: 50px;
    height: 38px;
    display: flex;
    align-items: center;

    &__image {
      width: 12px;
      height: 20px;
    }
  }

  .title {
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #ffffff;

    align-self: center;
    justify-self: center;
  }

  .icon-left {
    position: absolute;
    left: 56px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .icon-right {
    position: absolute;
    right: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .description {
      margin-right: 12px;
    }
  }
}

.map-menu {
  position: absolute;
  top: 44px;
  width: 100%;
  z-index: 1123;
  background-color: var(--color);

  .map {
    width: 100%;
    height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333333;
    transition: all 0.3s ease;
    overflow: hidden;
    opacity: 0;

    &.selected {
      color: var(--color);
    }
  }

  &.map-menu-open {
    height: calc(100vh - 44px);
    overflow-y: scroll;
    box-shadow: inset 0px -1px 1px #cccccc;

    .map {
      height: 54px;
      transition: all 0.3s ease;
      opacity: 1;
    }

    .map ~ .map {
      border-top: 1px solid rgba(51, 51, 51, 0.2);
    }
  }
}
</style>
